import {
  SmileyAngryFilled,
  SmileyAngry,
  SmileySadFilled,
  SmileySad,
  SmileySpeechlessFilled,
  SmileySpeechless,
  SmileyHappyFilled,
  SmileyHappy,
  SmileyPleasedFilled,
  SmileyPleased,
} from '@creditornot/cb-icons';
import { cssVariableThemedValue } from '@creditornot/cb-ingredients';
import * as React from 'react';

export type Props = {
  // 1-5
  rating: number;
  variant: Variant;
};

export type Variant = 'colored' | 'outline';

type IconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;

const ratingSmileys: Record<number, { colored: IconComponent; outline: IconComponent }> = {
  1: {
    colored: SmileyAngryFilled,
    outline: SmileyAngry,
  },
  2: {
    colored: SmileySadFilled,
    outline: SmileySad,
  },
  3: {
    colored: SmileySpeechlessFilled,
    outline: SmileySpeechless,
  },
  4: {
    colored: SmileyHappyFilled,
    outline: SmileyHappy,
  },
  5: {
    colored: SmileyPleasedFilled,
    outline: SmileyPleased,
  },
};
export const RatingSmiley: React.FC<React.SVGProps<SVGSVGElement> & Props> = ({ rating, variant, ...rest }) => {
  const ratingSmiley = ratingSmileys[rating];
  const RatingIcon = variant === 'colored' ? ratingSmiley?.colored : ratingSmiley?.outline;

  return RatingIcon ? (
    <RatingIcon
      fill={variant === 'outline' ? `var(${cssVariableThemedValue('textSecondary')})` : undefined}
      {...rest}
    />
  ) : null;
};
